import React from 'react';
import { Box, Text, VStack, Badge, Stack, Divider } from '@chakra-ui/react';

const InfoItem = ({ label, value }) => (
  <Stack direction="row" justify="space-between" align="flex-start" py={1} spacing={2}>
    <Text color="gray.500" fontSize="sm" minW="60px" flexShrink={0}>{label}</Text>
    <Text 
      fontWeight="bold" 
      fontSize="sm" 
      color="#222" 
      textAlign="right"
      wordBreak="break-word"
      overflowWrap="break-word"
      lineHeight="1.3"
      maxW="200px"
    >
      {value}
    </Text>
  </Stack>
);

const JobDetailsSidebar = ({ about, categories, skills }) => (
  <Box
    bg="white"
    borderRadius="lg"
    boxShadow="sm"
    p={{ base: 3, md: 5 }}
    w={{ base: '100%', md: '320px' }}
    minW={0}
  >
    <Text fontWeight="bold" fontSize={{ base: 'lg', md: 'xl' }} mb={2} color="#222">About this role</Text>
    <VStack align="stretch" spacing={1} mb={3}>
      {about.map((item, idx) => <InfoItem key={idx} label={item.label} value={item.value} />)}
    </VStack>
    <Divider my={2} />
    <Text fontWeight="bold" fontSize={{ base: 'md', md: 'lg' }} mb={2} color="#222">Categories</Text>
    <Stack direction="row" flexWrap="wrap" gap={2} mb={3}>
      {categories.map((cat, idx) => <Badge key={idx} colorScheme="yellow" variant="subtle">{cat}</Badge>)}
    </Stack>
    <Divider my={2} />
    {/* <Text fontWeight="bold" fontSize={{ base: 'md', md: 'lg' }} mb={2} color="#222">Required Skills</Text>
    <Stack direction="row" flexWrap="wrap" gap={2}>
      {skills.map((skill, idx) => <Badge key={idx} colorScheme="teal" variant="subtle">{skill}</Badge>)}
    </Stack> */}
  </Box>
);

export default JobDetailsSidebar; 